// @ts-nocheck
import { rowsPerPageInit } from "../../utils/constants/paginationConstants";
import {
  ARCHIVE_EVENT_FAILURE,
  ARCHIVE_EVENT_REQUEST,
  ARCHIVE_EVENT_SUCCESS,
  ASSIGN_CLIENT_FAILURE,
  ASSIGN_CLIENT_REQUEST,
  ASSIGN_CLIENT_SUCCESS,
  CLEAR_EVENT_REQUEST_LIST,
  DELETE_EVENT_FAILURE,
  DELETE_EVENT_REQUEST,
  DELETE_EVENT_SUCCESS,
  FETCH_NEW_EVENT_FAILURE,
  FETCH_NEW_EVENT_REQUEST,
  FETCH_NEW_EVENT_SUCCESS,
  SEARCH_NEW_EVENT_FAILURE,
  SEARCH_NEW_EVENT_REQUEST,
  SEARCH_NEW_EVENT_SUCCESS,
  SET_MULTIPLE_FIELDS_EVENT_REQUEST,
  UPDATE_CONTACT_INFORMATION_FAILURE,
  UPDATE_CONTACT_INFORMATION_REQUEST,
  UPDATE_CONTACT_INFORMATION_SUCCESS,
  UPDATE_EVENT_INFORMATION_FAILURE,
  UPDATE_EVENT_INFORMATION_REQUEST,
  UPDATE_EVENT_INFORMATION_SUCCESS,
} from "../constants/eventRequest";
import {
  EVENT_EDITED_AFTER_ESTIMATE_FAILURE,
  EVENT_EDITED_AFTER_ESTIMATE_REQUEST,
  EVENT_EDITED_AFTER_ESTIMATE_SUCCESS,
} from "../constants/eventRequestDetails";

const initialState = {
  eventRequests: [],
  searchString: "",
  currentPage: 1,
  totalPages: null,
  totalEvents: null,
  isLoading: true,
  ucLoading: false,
  archiveLoading: false,
  filtersDate: null,
  rowsPerPage: rowsPerPageInit,
  searchBy: [],
};

const eventRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MULTIPLE_FIELDS_EVENT_REQUEST:
      return {
        ...state,
        ...action?.payload,
      };

    case FETCH_NEW_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchString: action.payload?.searchString,
        searchBy: action?.payload?.searchBy,
        rowsPerPage: action?.payload?.rowsPerPage,
        filtersDate: action?.payload?.filtersDate,
      };

    case FETCH_NEW_EVENT_SUCCESS:
      return {
        ...state,
        eventRequests:
          action.payload?.events ??
          (Array.isArray(action.payload?.data) ? action.payload.data : []),
        currentPage: action.payload?.currentPage ?? action.payload?.pagination?.currentPage,
        totalPages: action.payload?.totalPages ?? action.payload?.pagination?.totalPages,
        totalEvents: action.payload?.totalEvents ?? action.payload?.pagination?.totalItems,
        isLoading: false,
      };

    case FETCH_NEW_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // search new event request
    case SEARCH_NEW_EVENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SEARCH_NEW_EVENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        eventRequests:
          action.payload?.events ??
          (Array.isArray(action.payload?.data) ? action.payload.data : []),
        totalEvents: action.payload?.totalEvents ?? action.payload?.pagination?.totalItems,
        currentPage: action.payload?.currentPage ?? action.payload?.pagination?.currentPage,
        totalPages: action.payload?.totalPages,
      };
    case SEARCH_NEW_EVENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // assing client request
    case ASSIGN_CLIENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ASSIGN_CLIENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case ASSIGN_CLIENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // event edited after estimate is generated
    case EVENT_EDITED_AFTER_ESTIMATE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case EVENT_EDITED_AFTER_ESTIMATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case EVENT_EDITED_AFTER_ESTIMATE_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // update contact information
    case UPDATE_CONTACT_INFORMATION_REQUEST:
      return {
        ...state,
        ucLoading: true,
      };
    case UPDATE_CONTACT_INFORMATION_SUCCESS:
      return {
        ...state,
        ucLoading: false,
      };
    case UPDATE_CONTACT_INFORMATION_FAILURE:
      return {
        ...state,
        ucLoading: false,
      };

    // update event information
    case UPDATE_EVENT_INFORMATION_REQUEST:
      return {
        ...state,
        ucLoading: true,
      };
    case UPDATE_EVENT_INFORMATION_SUCCESS:
      return {
        ...state,
        ucLoading: false,
      };
    case UPDATE_EVENT_INFORMATION_FAILURE:
      return {
        ...state,
        ucLoading: false,
      };

    // delete event request
    case DELETE_EVENT_REQUEST:
      return {
        ...state,
      };
    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
      };
    case DELETE_EVENT_FAILURE:
      return {
        ...state,
      };

    // archive event
    case ARCHIVE_EVENT_REQUEST:
      return {
        ...state,
        archiveLoading: true,
      };

    case ARCHIVE_EVENT_SUCCESS:
      return {
        ...state,
        archiveLoading: false,
      };

    case ARCHIVE_EVENT_FAILURE:
      return {
        ...state,
        archiveLoading: false,
      };

    // clear event request list
    case CLEAR_EVENT_REQUEST_LIST:
      return initialState;

    default:
      return state;
  }
};

export default eventRequestReducer;
export { initialState };